import Vue from 'vue';
import teamMemberService from '../team_member';

const success = (context, response, userData, isFromUpdate) => {
  userData.avatar = response.data.image;
  if (!isFromUpdate) {
    teamMemberService.storeTeamMember(userData, context);
  } else {
    context.update_user(userData);
  }
};

const failed = (context, error) => {
  if (error.response && error.response.data && error.response.data.msg) {
    context.loading = false;
    toastr.error(error.response.data.msg.image[0]);
  } else {
    toastr.error(error.response.data.msg);
  }
};

export default (context, formData, userData, isFromUpdate = false) => Vue.$http.post('/files', formData).then((response) => {
  if (response && response.status === 200) {
    success(context, response, userData, isFromUpdate);
  }
}).catch((error) => {
  failed(context, error);
});



// WEBPACK FOOTER //
// ./src/app/services/account/uploadMemberAvatar.js